import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDUdi06V8jeqIAHDBUkFPNRtHiLq79bYh4",
  authDomain: "journalcoffee.firebaseapp.com",
  projectId: "journalcoffee",
  storageBucket: "journalcoffee.firebasestorage.app",
  messagingSenderId: "569853990005",
  appId: "1:569853990005:web:d4a4f29e3664817b49143c",
  measurementId: "G-PG1HH8Z6VR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
try { getAnalytics(app); } catch (_) {}

export default app;
